import React from 'react'
import { Container } from 'react-bootstrap'

const DashboardContent = (props) => {
    return (
        <div className='dashboard_content'>
            <Container>
                {props.children}
            </Container>
        </div>
    )
}

export default DashboardContent
